// extracted by mini-css-extract-plugin
module.exports = {"default":"PostStats--default--3L7NF","dot":"PostStats--dot--b00TV"};